import React from 'react'
import TextField from '@mui/material/TextField'
import AutocompleteFetch from '@/javascript/presentation/components/inputs/autocomplete-fetch-input'

type viewOption = { label: string; value: string }

type Props = {
  viewMode: viewOption[]
  viewOptions: viewOption[]
  setViewMode: React.Dispatch<React.SetStateAction<viewOption[]>>
}

const ViewModeInput: React.FC<Props> = ({ viewMode, setViewMode, viewOptions }) => {
  return (
    <AutocompleteFetch
      label="Visualizar" value={viewMode} setValue={setViewMode}
      fetchOptions={() => Promise.resolve(viewOptions)}
      renderValue={null}
      renderInput={(params) => (
        <TextField
          {...params} label="Visualizar" variant="outlined"
          error={viewMode.length === 0}
        />
      )}
    />
  )
}

export default ViewModeInput
